import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { GenesysCloudPlatformApiService } from '../../../common/services/genesys-cloud-platform-api.service';
import { MessageData } from '../models/message-data.model';
import { PaginationResponse } from '../../../common/models/pagination-response.model';
import { ConversationApiBase } from '../../common/services/conversation-api-base.service';
import { ConversationResponse } from 'common/store/genesys-cloud/conversations/common/models/conversation-response.models';
import { CommunicationType } from 'common/store/genesys-cloud/conversations/common/models/communication-type.enum';

@Injectable({
  providedIn: 'root'
})
export class MessageConversationApiService extends ConversationApiBase {
  static readonly ConversationsPath = 'api/v2/conversations';
  static readonly TransferConversationPath = (conversationId: string, participantId: string) =>
    `${ConversationApiBase.ConversationsPath}/messages/${conversationId}/participants/${participantId}/replace`;

  constructor(readonly api: GenesysCloudPlatformApiService) {
    super(api, 'messages');
  }

  getMessageConversations$(): Observable<ConversationResponse[]> {
    return this.getConversations$(CommunicationType.Message);
  }

  getMessages$(conversationId: string, messageIds: string[]): Observable<MessageData[]> {
    const path = `${ConversationApiBase.ConversationsPath}/messages/${conversationId}/messages/bulk`;

    return this.api.post$<PaginationResponse<MessageData>>(path, messageIds).pipe(
      map(response => response.entities)
    );
  }

  sendMessage$(conversationId: string, communicationId: string, textBody: string): Observable<MessageData> {
    const path = `${ConversationApiBase.ConversationsPath}/messages/${conversationId}/communications/${communicationId}/messages`;
    const body = {
      textBody
    };

    return this.api.post$(path, body);
  }

  transferConversationToUser$(conversationId: string, participantId: string, userId: string): Observable<{}> {
    return this.api.post$(MessageConversationApiService.TransferConversationPath(conversationId, participantId), {
      userId
    });
  }

  transferConversationToQueue$(conversationId: string, participantId: string, queueId: string): Observable<{}> {
    return this.api.post$(MessageConversationApiService.TransferConversationPath(conversationId, participantId), {
      queueId
    });
  }

  typing$(conversationId: string, communicationId: string): Observable<{}> {
    const path = `${ConversationApiBase.ConversationsPath}/messages/${conversationId}/communications/${communicationId}/typing`;
    return this.api.post$(path, {
      typing: {
        type: 'On'
      }
    });
  }
}
